import SupplierResponseViewContainer from "./Containers/SupplierResponseViewContainer";
export default SupplierResponseViewContainer;
